import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from "react";
import { useStaticQuery } from "gatsby";
import { LayoutWrapper } from "../components/LayoutWrapper/LayoutWrapper";
import styled, { ThemeProvider } from "../styled-components";
import { appTheme } from "../appTheme";
import { NavBar } from "../components/NavBar/NavBar";
import { Footer } from "../components/Footer/Footer";
import { GlobalStyle } from "../globalStyle";
import SidebarLayout from "../components/UserComponents/layouts/Sidebar";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { isTocEnabled } from "./MarkdownLayout";
import { RedirectToLogin } from "../components/RedirectToLogin";
import { useIsLoggedIn } from "../ui/auth/utils";
import { flattenNestedItems, withPathPrefix } from "../utils";
import { PAGE_TYPES } from "../../constants";
import { mediaCSS } from "@redocly/reference-docs";
import { PageDataContext } from "./PageDataContext";
import { App } from "../components/UserComponents/App";
var CustomTemplateWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1 0 auto;\n  line-height: 1.5;\n  padding: 0;\n  color: ", ";\n  position: relative;\n\n  ", "\n"])), function (_ref) {
  var a = _ref.theme;
  return a.colors.text.primary;
}, function (_ref2) {
  var a = _ref2.theme;
  return mediaCSS({
    fontFamily: a.typography.fontFamily
  });
}),
    LandingWrapper = styled.section(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  flex: 1 0 auto;\n  position: relative;\n"])));
var LinkKey;

(function (a) {
  a.PREV = "redocPrevLink", a.NEXT = "redocNextLink";
})(LinkKey || (LinkKey = {}));

var LabelKey;

(function (a) {
  a.PREV = "redocPrevLabel", a.NEXT = "redocNextLabel";
})(LabelKey || (LabelKey = {}));

function SidebarsWrapper(_ref3) {
  var a = _ref3.children,
      b = _ref3.sidebarName,
      c = _ref3.pageId,
      d = _ref3.showNextButton,
      e = _ref3.showPrevButton;

  function f(_x, _x2) {
    return _f.apply(this, arguments);
  }

  function _f() {
    _f = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(a, b) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch(withPathPrefix("_auth/sidebar/" + encodeURIComponent(a), b));

            case 3:
              return _context2.abrupt("return", _context2.sent.json());

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", (console.log(_context2.t0), m));

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return _f.apply(this, arguments);
  }

  var _useStaticQuery = useStaticQuery("2667623876"),
      g = _useStaticQuery.allSidebar,
      _useStaticQuery$siteC = _useStaticQuery.siteConfig,
      h = _useStaticQuery$siteC.withRbac,
      i = _useStaticQuery$siteC.showNextButton,
      j = _useStaticQuery$siteC.showPrevButton,
      k = _useStaticQuery.site.pathPrefix,
      l = g.nodes.find(function (a) {
    return a.name === b;
  }),
      _React$useState = React.useState(void 0),
      m = _React$useState[0],
      n = _React$useState[1];

  if (React.useEffect(function () {
    n(void 0), h && _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = "development" === process.env.NODE_ENV;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t1 = n;
              _context.next = 5;
              return f(b, k);

            case 5:
              _context.t2 = _context.sent;
              (0, _context.t1)(_context.t2);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [b, h]), !l) throw new Error("Unexpected error: can't find sidebar details");

  var o = m || l,
      p = flattenNestedItems(o.items).filter(function (a) {
    return "page" === a.type && !!a.pageId;
  }),
      q = p.findIndex(function (a) {
    return a.pageId === c;
  }),
      r = function r(a) {
    if (-1 === q) return;
    var b = p[q],
        c = b[LinkKey[a]],
        d = b[LabelKey[a]];
    if (c && d) return {
      link: c,
      label: d
    };
    var e = "PREV" === a ? q - 1 : q + 1;
    return p[e];
  },
      s = !0 === e || j && !1 !== e ? r("PREV") : void 0,
      t = !0 === d || i && !1 !== d ? r("NEXT") : void 0;

  return a(o, s, t);
}

export default function DefaultLayout(a) {
  var _f$contentItem, _f$contentItem3;

  var b = a.pageContext.isLanding;
  var c = a.children,
      d = a.pageContext,
      e = a.location,
      f = a.data;
  if ("develop" === process.env.GATSBY_BUILD_STAGE && "undefined" != typeof window && "localhost" !== window.location.hostname && "127.0.0.1" !== window.location.hostname && "" !== window.location.hostname && !window.location.hostname.endsWith(".apps.codespaces.githubusercontent.com")) return "Development mode is only allowed in localhost";

  var _ref5 = (f === null || f === void 0 ? void 0 : (_f$contentItem = f.contentItem) === null || _f$contentItem === void 0 ? void 0 : _f$contentItem.data) || {},
      g = _ref5.redocStoreStr,
      h = React.useMemo(function () {
    return g ? JSON.parse(g) : null;
  }, [g]),
      i = React.useMemo(function () {
    var _h$definition$data, _h$definition, _f$contentItem2, _f$contentItem2$data;

    return {
      referenceDocsStoreJson: h,
      rawApiDefinition: (_h$definition$data = h === null || h === void 0 ? void 0 : (_h$definition = h.definition) === null || _h$definition === void 0 ? void 0 : _h$definition.data) !== null && _h$definition$data !== void 0 ? _h$definition$data : null,
      frontmatter: d.data,
      pageId: d.pageId,
      lastModified: f === null || f === void 0 ? void 0 : (_f$contentItem2 = f.contentItem) === null || _f$contentItem2 === void 0 ? void 0 : (_f$contentItem2$data = _f$contentItem2.data) === null || _f$contentItem2$data === void 0 ? void 0 : _f$contentItem2$data.lastModified
    };
  }, [h, d.data, d.pageId]),
      j = isTocEnabled(d),
      k = d.type === PAGE_TYPES.referenceDocsPage || d.type === PAGE_TYPES.referenceDocsOverview;

  var l = d.showPrevButton,
      m = d.showNextButton;
  var n = b && !d.sidebarName,
      o = useIsLoggedIn();
  (f === null || f === void 0 ? void 0 : (_f$contentItem3 = f.contentItem) === null || _f$contentItem3 === void 0 ? void 0 : _f$contentItem3.data.requestLogin) && !o && (l = !1, m = !1, c = /*#__PURE__*/React.createElement(RedirectToLogin, null));
  var p = n ? /*#__PURE__*/React.createElement(LandingWrapper, null, c) : !d.sidebarName ? /*#__PURE__*/React.createElement(CustomTemplateWrapper, {
    isRedoc: k
  }, c) : /*#__PURE__*/React.createElement(SidebarsWrapper, {
    sidebarName: d.sidebarName,
    pageId: d.pageId,
    showPrevButton: l,
    showNextButton: m
  }, function (a, b, f) {
    return /*#__PURE__*/React.createElement(SidebarLayout, {
      location: e,
      items: a.items || [],
      context: JSON.parse(a.context || "null"),
      prevPage: b,
      nextPage: f,
      withRightPanel: k && appTheme.layout.showDarkRightPanel,
      isReferenceDocs: k,
      withToc: j,
      pageId: d.pageId,
      apiVersionId: d.apiVersionId,
      apiVersions: d.apiVersions
    }, c);
  });
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: appTheme
  }, /*#__PURE__*/React.createElement(PageDataContext.Provider, {
    value: i
  }, /*#__PURE__*/React.createElement(App, {
    location: e
  }, /*#__PURE__*/React.createElement(LayoutWrapper, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(PageHeader, {
    seo: d.seo
  }), n ? null : /*#__PURE__*/React.createElement(NavBar, {
    standalone: !0,
    location: e,
    sidebarName: d.sidebarName
  }), p, /*#__PURE__*/React.createElement(Footer, null)))));
}